import { render } from "./PricesRequests.vue?vue&type=template&id=1c6659d7"
import script from "./PricesRequests.vue?vue&type=script&lang=js"
export * from "./PricesRequests.vue?vue&type=script&lang=js"

import "./PricesRequests.vue?vue&type=style&index=0&id=1c6659d7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__